import React, { createContext, useEffect, useState } from "react";
import NavBar from "./NavBar";
import {
  Box,
  //useTheme
} from "@mui/material";
import MenuBar from "./MenuBar";
import ConfigurationsAera from "./configurationAeras";
import Dashboards from "./dasboards";
import Report from "./reports";
import MyNotification from "./components/MyNotification";

export const MainLayOutContect = createContext(null);
function MainLayout() {
  const [togleCollapse, setTogleCollapse] = useState(
    localStorage.getItem("togleCollapse") === "true" ? true : false
  );
  const [isMenu, setIsMenu] = useState(0);
  const [notificationSwitch, setNotificationSwitch] = useState(
    localStorage.getItem("notificationSwitch") === "true" ||
      !localStorage.getItem("notificationSwitch")
      ? true
      : false
  );
  const [soundSwitch, setSoundSwitch] = useState(
    localStorage.getItem("soundSwitch") === "true" ||
      !localStorage.getItem("soundSwitch")
      ? true
      : false
  );

  useEffect(() => {
    localStorage.setItem("togleCollapse", togleCollapse);
  }, [togleCollapse]);

  useEffect(() => {
    if (notificationSwitch) {
      localStorage.setItem("notificationSwitch", notificationSwitch);
    } else {
      localStorage.setItem("notificationSwitch", false);
    }
  }, [notificationSwitch]);

  useEffect(() => {
    if (soundSwitch) {
      localStorage.setItem("soundSwitch", soundSwitch);
    } else {
      localStorage.removeItem("soundSwitch", false);
    }
  }, [soundSwitch]);

  return (
    <MainLayOutContect.Provider
      value={{
        togleCollapse,
        setTogleCollapse,
        isMenu,
        setIsMenu,
        notificationSwitch,
        setNotificationSwitch,
        soundSwitch,
        setSoundSwitch,
      }}
    >
      <MyNotification />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <NavBar />
        <Box sx={{ flexGrow: 1, display: "flex", overflow: "hidden" }}>
          <MenuBar />
          {isMenu === 0 && <Dashboards />}
          {isMenu === 1 && <ConfigurationsAera />}
          {isMenu === 2 && <Report />}
        </Box>
      </Box>
    </MainLayOutContect.Provider>
  );
}

export default MainLayout;
